import React, { useState, useEffect } from "react";
import { Modal, Form, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { refreshPage, toastStyle } from "../../../Helpers/Utils/Common";
import { updateAdjustmentStatus } from "../../../Helpers/apiCalls/Inventory/AdjustmentApi";
import { updateAdjustmentStatusPotato } from "../../../Helpers/apiCalls/PotatoCorner/Inventory/AdjustmentApi";
import ReactLoading from "react-loading";

export default function AdjustmentModal(props) {
    const [remarks, setRemarks] = useState("");
    const [isConfirmClicked, setIsConfirmClicked] = useState(false);
    const navigate = useNavigate();

    async function handleSetAdjustmentStatus() {
        const storeAdjustments = props.ids;
        // var mango = props.ids.filter((data) => data.type === "mango_magic");
        // var potato = props.ids.filter((data) => data.type === "potato_corner");
        // ;
        // 
        // 
        if (isConfirmClicked) {
            return;
        }
        if (storeAdjustments.length !== 0) {
            setIsConfirmClicked(true);
            const response = await updateAdjustmentStatus(
                storeAdjustments,
                remarks,
                props.status,
                props.request_type
            );
            ;
            if (response.data) {

                toast.success(response.data.message, {
                    style: toastStyle(),
                });
                    // if (props.type === "approved") {
                    //     toast.success("Adjustment/s approved successfully!", {
                    //         style: toastStyle(),
                    //     });
                    // } else if (props.type === "disapproved") {
                    //     toast.success(
                    //         "Adjustment/s disapproved successfully!",
                    //         { style: toastStyle() }
                    //     );
                    // }

                setTimeout(() => {
                    refreshPage();
                }, 1000);
            } else {
                setIsConfirmClicked(false);
                response.error?.response?.data?.messages.map((data) => {
                    return toast.error(data);
                })
            }
            setIsConfirmClicked(false);
        }
    }

    return (
        <div>
            <Modal show={props.show} onHide={props.hide} size="lg" centered>
                <Modal.Header className="return-header">
                    <span
                        className={
                            props.type === "disapprove"
                                ? "color-red"
                                : "text-warning"
                        }
                    >
                        {props.type === "disapprove"
                            ? "DISAPPROVE "
                            : "APPROVE "}
                            {props.request_type.toUpperCase()}
                            {" "}
                            ADJUSTMENTS{" "}
                    </span>
                </Modal.Header>
                <Modal.Body className="return-body text-center">
                    <span>
                        Are you sure you want to {props.type} these selected
                        adjustments?
                    </span>
                    <Col className="text-left pt-3">
                        <span>REMARKS</span>
                        <Form.Control
                            as="textarea"
                            name="remarks"
                            defaultValue={remarks}
                            className="nc-modal-custom-row-grey"
                            onChange={(e) => setRemarks(e.target.value)}
                        />
                        <div className="d-flex justify-content-end my-4 pt-1 d-flex-responsive"> 
                            <button
                                type="button"
                                className={
                                    props.type === "disapprove"
                                        ? "button-warning me-3"
                                        : "button-secondary me-3"
                                }
                                onClick={props.hide}
                            >
                                Close
                            </button>
                            {isConfirmClicked ? (
                                <div
                                    className={
                                        props.type === "disapprove"
                                            ? "button-primary d-flex justify-content-center"
                                            : "button-primary d-flex justify-content-center"
                                    }
                                >
                                    <ReactLoading
                                        type="bubbles"
                                        color={
                                            props.type === "disapprove"
                                                ? "#FFFFFF"
                                                : "#FFFFFF"
                                        }
                                        height={50}
                                        width={50}
                                    />
                                </div>
                            ) : (
                                <button
                                    type="button"
                                    className={
                                        props.type === "disapprove"
                                            ? "button-primary"
                                            : "button-primary"
                                    }
                                    onClick={handleSetAdjustmentStatus}
                                >
                                    Confirm
                                </button>
                            )}
                        </div>
                    </Col>
                </Modal.Body>
            </Modal>
        </div>
    );
}
